export default __webpack_public_path__ + "prisma-logo-short-white-colored-dot-73f904f2576506c8c40eca45bb6eea4f.svg";